import React from 'react';
import { HStack, Text, Box } from 'native-base';

const DatasetTableHeader: React.FC = () => {
  return (
    <Box
      bg="coolGray.100"
      borderRadius="md"
      px={4}
      py={3}
      mb={2}
      borderWidth={1}
      borderColor="coolGray.300"
      shadow={1}
    >
      <HStack
        space={2}
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Text flex={0.5} textAlign="center" fontWeight="bold" fontSize="sm" color="coolGray.700">
          Serial
        </Text>
        <Text flex={2} fontWeight="bold" fontSize="sm" color="coolGray.700">
          Dataset ID
        </Text>
        <Text flex={1} fontWeight="bold" fontSize="sm" color="coolGray.700">
          Grain Type
        </Text>
        <Text flex={1} fontWeight="bold" fontSize="sm" color="coolGray.700">
          Created By
        </Text>
        <Text flex={1} textAlign="center" fontWeight="bold" fontSize="sm" color="coolGray.700">
          Status
        </Text>
        <Text flex={1} textAlign="center" fontWeight="bold" fontSize="sm" color="coolGray.700">
          Updated
        </Text>
        <Box minW="160">
          <Text textAlign="center" fontWeight="bold" fontSize="sm" color="coolGray.700">
            Actions
          </Text>
        </Box>
      </HStack>
    </Box>
  );
};

export default DatasetTableHeader;